<!--
@name 硕士教育-健康管理硕士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          随着《“健康中国2030”规划纲要》将大健康产业正式上升为国家战略，大健康产业迎来了快速发展的机遇期，大健康产业研究、消费医疗、医疗心理学与心理健康等医疗健康相关领域的研究和实践也显得尤为重要。行业迫切需求兼顾人性化医疗服务与市场化运营管理的医疗健康行业复合型人才，其拥有全球视野、多元化教育背景以及跨行业发展实践成为人才核心竞争力。
          为了更好地适应这一发展趋势，我们在国内开展健康管理硕士「Master ofHealth
          Administration」学位课程，加强跨学科合作和交流，培养把握时代脉搏、具备实战能力的国际人才。
        </div>
        <div class="selector-indent">
          为了更好地适应这一发展趋势，我们在国内开展健康管理硕士「Master ofHealth
          Administration」学位课程，加强跨学科合作和交流，培养把握时代脉搏、具备实
          战能力的国际人才。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">学位国际认可</p>
          <p>
            遵循国际商学院协会(AACSB)
            标准设置课程，引入国际先进管理理念教材，
            依托经典案例分析，深化知识体系理解。
          </p>
          <p class="advantage-title">中国教育部备案</p>
          <p> 中国教育部“涉外监管信息网”公开备案。</p>
          <p class="advantage-title">国际标准课程</p>
          <p>
            基于国际商学院协会（AACSB)
            标准的课程设置，引入国际先进管理理念教材，
            结合经典案例化教学分析，打造推动医疗健康管理全面发展课程体系。</p>
          <p class="advantage-title">名师大家云集</p>
          <p>
            云集国内外专家师资，一流大学与行业专家强强联合。
          </p>
          <p class="advantage-title">聚焦产业发展</p>
          <p> 聚焦产业新趋势，解构行业新政策，解决发展难题。</p>
          <p class="advantage-title">国际交流合作</p>
          <p> 搭建国际化交流平台，促进校友共建共赢。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养方式</div>
        <div>
          法国布雷斯特高等商学院健康管理硕士学位课程采用线上教学加线下实践、自主
          学习和毕业论文相结合的方式进行为期一年半的学习，毕业季时组织学生集体去
          法国参加研修及毕业典礼。
        </div>
      </div>
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程简介</div>
        <p>【学习形式】线上学习与课堂面授学习相结合，铺以现场教学、案例分析、小组讨论等</p>
        <p>【授课地点】北京,健康管理硕士学位课程学制1.5年，每月集中授课2天，修满60学分可参加毕业论文答辩。</p>
        <img src="@/assets/images/personRain/dgm-course01.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/dgm-course02.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">师资介绍</div>
        <p>董四平：
          现任国家卫生健康委医院管理研究所医疗政策部主任、研究员、教授、博导。兼任清华大学
          医疗管理评价研究所所长助理、中国研究型医院学会住院管理专委会副主委、中国研究型医
          院学会评价评估专委会副秘书长、中国卫生经济学会理论与政策专委会常委、中国医促会国
          际医疗旅游分会副秘书长、全国公立医院院长职业化建设专委会医院评审评价分会委员、国
          家自然科学基金评审专家、《中国卫生质量管理》杂志编委、《中国卫生政策研究》和
          Health Policy等6家SCI期刊审稿人、国际卫生经济学会（iHEA)会员。</p>
        <p>黄天荫：
          清华大学讲席教授，眼科医生、医师科学家、新加坡国家科学院院士、美国国家医学院外籍
          院士，毕业于新加坡国立大学医学院，并于美国约翰·霍普金斯大学获得博士学位。曾任新
          加坡全国眼科中心医学主任兼眼科教授、新加坡国立大学眼科系主任、澳大利亚墨尔本大学
          眼科系主任。</p>
        <p>董关鹏：
          中国传媒大学教授、博士生导师，国家公共关系与战略传播研究院院长，港澳台与世界事务研
          究中心主任。兼任中国公共关系协会副会长、政府公共关系委员会主任委员；中国高等教育学
          会公共关系教育专业委员会理事长；全国工商联宣传教育委员会副主任委员；国务院新闻办公
          室新闻发布策划与评估专家；国务院食品安全委员会专家委员会委员；最高人民法院司法传播
          策划专家；国家生态环境保护专家委员会委员；国家核应急协调专家委员会委员；全国新型冠
          状病毒肺炎疫情处置专家组成员；中央赴湖北指导组随行新闻发布专家等。</p>
        <p>王维民：
          北京大学医学部副主任，医学博士，主任医师，博士生导师。现为教育部临床医学专业认证
          工作委员会主任委员、2018-2022年教育部高等学校临床医学类专业教学指导委员会副主任
          委员、教育部医学教育专家委员会秘书长、中国医药教育协会医学模拟教育专业委员会主任
          委员、中国高等教育学会医学教育专业委员会常务理事兼副秘书长、中华医学会医学教育分
          会候任主委等。</p>
        <p>薛镭：
          清华大学文化经济研究院副院长，经管学院创新创业与战略系教授，清华大学医院管理研究
          院副院长、经管学院医疗管理研究中心主任。
          薛镭教授曾担任经管学院副院长(1998-2005)，负责学院高层管理塔训工作(1998-2014)，
          主持和参与北京奥运会组委会、国家卫计委，中国工程院，北京市卫生局等组织和单位委托
          的多项科研项目，在国际国内顶级学术刊物上发表多篇论文。</p>
        <p>刘继同：
          北京大学公共卫生学院教授，博士生导师。现任国务院妇女儿童工作委员会办公室智库专家。
          同时担任WHO、UNICEF、UNDP、国务院多个部委政策咨询专家和1O多个全国性协会常务
          理事、理事和部委专家委员会委员。现任中国生命关怀协会副会长，兼任中国生命关怀协会临
          终关怀与健康社会工作专业委员会主委，儿童临终关怀与家庭卫生保健专业委员会主委。</p>
        <p>韩布新：
          中国科学院心理研究所二级研究员、博士生导师、学位委员会主任；中国科学院大学心理系
          岗位教授、人文学科群学位委员会副主任；中国心理学会原理事长、临床心理学注册工作组
          常委；中国老年学与老年医学学会副会长；中国心理卫生协会理事、首批注册督导师；国家
          老龄委专家委员会委员；国际应用心理协会（IAAP)原秘书长（2014-2018)、七分会（
          认知老年学)主席；亚洲心理协会（APSVA)主席。</p>
        <p>刘希平：
          中国科学院心理研究所博士，天津师范大学教授、博士生导师。天津市教学名师，天津市优秀
          教师，中国心理学会认定心理学家。中国心理学会普通心理与实验心理专业委员会委员，中国
          心理卫生协会青少年心理卫生专业委员会委员，中国科普作家协会心理学科普创新专业委员会
          委员，中国心理学会临床与咨询心理学专业委员会注册督导师。美国伊利诺伊大学香槟分校研
          究学者。主要研究领域为记忆与元记忆的发展、儿童的社会认知等、积极行为塑造等。</p>
        <p>和红：
          北京大学公共卫生学院医学博士。现为中国人民大学社会与人口学院社会医学教研室主任，
          人口与发展研究中心教授，健康研究所所长。主要研究方向为人口健康、社会医学、流行病
          学及生殖健康等。曾于2005年7月在美国哥伦比亚大学做访问学者。2007年至2008年在美
          国杜克大学做访问学者，从事人口健康及慢性病研究，已发表学术论文数十篇。</p>
        <p>邱月：
          北京大学博士，哈佛大学访问学者。现任清华大学医院管理研究院副教授，曾任国务院发展
          研究中心研究员。2012-2022年，主持20余项课题研究，包括国务院研究室、国家卫健委、
          国家医保局、中国工程院、国际组织及行业资助课题；承担多部委及世界银行、世界卫生组
          织、联合国人口基金的专家咨询工作；完成论文著作40余篇，撰写数十篇报告上报党中央、
          国务院，多篇报告获副国级及以上领导批示，多项研究成果被部委和地方政府采纳，多部研
          究报告获中英文出版，在柳叶刀等学术期刊刊发学术论文。曾被授予“国务院发展研究中心
          岗位能手”称号。</p>
        <p>耿劲松：
          南通大学医学院医学信息学系教授、硕士生导师。复旦大学社会医学与卫生事业管理博士研
          究生毕业。曾担任亚太地区循证医学研讨会组委会成员和学术委员，现兼任中国医疗保健国
          际交流促进会循证医学青年委员会委员，中华医学会医学信息学分会教育学组委员，国际多
          准则循证决策协作网EVIDEM COLLABORATION委员会成员。曾多次在国际卫生技术评估
          和循证医学会议进行口头报告。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="@/assets/images/personRain/mba-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科及同等学历，三年以上工作经验</p>
        <p>大专及同等学历，五年以上管理经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
        <!-- 报名咨询 -->
        <div class="cont-item">
          <div class="title-image">报名咨询</div>
          <p>邱老师 18600655972 ； 张老师 17701207193 ； 陈老师13611097764</p>
        </div>
        <!-- 报名咨询 -->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">健康管理硕士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 相关资料下载 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'HealthMba',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3B/BB/wKgCEmbrmRqAItknAH0Ryf4g7U0413.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/healthMba.vue